import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CompanyService } from '@services/company.service';
import claimTemplateCategoriesService from '@services/claim_template_categories.service';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import claimTemplateTasksService from '@rd-web-markets/shared/dist/services/claim_groups/claim_template_tasks.service';
import getClaimGroupsService from '@rd-web-markets/shared/dist/services/claim_groups/getClaimGroups.service';
import useRecentVisits from '@rd-web-markets/shared/dist/hooks/useRecentVisits';
import { useSetCompanyBreadcrumb } from '@rd-web-markets/shared/dist/util/hooks/useSetCompanyBreadcrumb';
import MarketClaimGroupMasterPage from '@rd-web-markets/market/dist/claim_group/MarketClaimGroupMasterPage';
import ClaimGroupNavigation from './ClaimGroupNavigation';

const ClaimGroupMasterPage = ({ handleToaster, accountType }) => {
  const { company_id, claim_group_id } = useParams();
  const [company, setCompany] = useState(null);
  const [claimGroup, setClaimGroup] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allClaimGroups, setAllClaimGroups] = useState([]);
  const { addRecentClaimGroupId, addRecentCompanyId } = useRecentVisits();

  useSetCompanyBreadcrumb(company, accountType);

  const getAllClaimGroups = useErrorHandling(useCallback(async () => {
    const allClaimGroups = await getClaimGroupsService.all(company_id, 'get_all=true'); // query is for super_consultants user type
    const claimGroup = allClaimGroups.find(c => c.id === Number(claim_group_id)) || allClaimGroups[0];
    setClaimGroup(claimGroup);
    setAllClaimGroups(allClaimGroups);
    claimGroup && addRecentClaimGroupId(String(claimGroup.id));
  }, [company_id, claim_group_id, addRecentClaimGroupId]));

  const resetCompany = useErrorHandling(useCallback(async () => {
    const company = await CompanyService.get(company_id);
    setCompany(company);
    return company;
  }, [company_id]));

  const resetCompanyAndClaimGroup = useErrorHandling(useCallback(async () => {
    await resetCompany();
  }, [resetCompany]));

  const updateClaimGroupTask = claimTemplateTasksService.useUpdateClaimGroupTask({ claimGroup, setClaimGroup, setLoading, handleToaster });

  const markTaskComplete = useErrorHandling(useCallback(async (category, categoryIndex, taskIndex, claimGroup) => { //claimGroup task
    setLoading(true);
    const response = await claimTemplateCategoriesService.update(claimGroup.id, category, categoryIndex, taskIndex);
    setClaimGroup({...claimGroup, ...response });
    handleToaster('Task Updated!');
    setLoading(false);
  }, [handleToaster]));

  useEffect(() => {
    getAllClaimGroups();
    resetCompanyAndClaimGroup(company_id, claim_group_id);
    addRecentCompanyId(company_id);
    // eslint-disable-next-line
  }, [company_id, claim_group_id, resetCompanyAndClaimGroup]);

  if (!company) return <Loading />;

  return (
    <MarketClaimGroupMasterPage
      company={company}
      claimGroup={claimGroup}
      allClaimGroups={allClaimGroups}
      accountType={accountType}
      companyId={company_id}
      claimGroupId={claim_group_id}
      loading={loading}
      setLoading={setLoading}
      markTaskComplete={markTaskComplete}
      updateClaimGroupTask={updateClaimGroupTask}
      resetCompany={resetCompany}
      ClaimGroupNavigation={ClaimGroupNavigation}
    />
  );
};

export default ClaimGroupMasterPage;
